import {Component, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../../core/configs/app-config';
import {SelectItem} from 'primeng/api';
import {UserService } from "../../../../core/services/user.service";

@Component({
    selector: 'relatie-dialog',
    templateUrl: 'relatiedialog.component.html',
    styleUrls  : ['./relatiedialog.component.scss']
  })
  export class PlanningMdwRelatieDialog {
    private headers: Headers = new Headers({ "Content-Type": "application/json",
    "Authorization": this.userService.getAuthenticationtoken() });
    selectedRelaties: any[] = [];
    relaties: SelectItem[] = [];
    config: any;
    constructor(public dialogRef: MatDialogRef<PlanningMdwRelatieDialog>,private userService:UserService, @Inject(MAT_DIALOG_DATA) public data:  any[], @Inject(HttpClient) private http?: HttpClient) {
      this.config = {
        "SERVERPROTOCOL": AppConfig.ApiProtocol,
        "SERVERURL": AppConfig.ApiLoginHost,
        "SERVERPORT": AppConfig.ApiPort,
        "APPLICATIONID": AppConfig.ApiApplicationId,
        "METHOD": AppConfig.ApiMethod,
        "LOGINURL": AppConfig.ApiLoginUrl,
        "STACKURL": AppConfig.ApiUrl
      };
      
      
    }

        ngOnInit() {
          console.log(this.data["relaties"]);

        let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/relatieoverzicht";
      
          var get = this.http.get(conString);
          get.subscribe(     
          (results:any) => {
          for (var result of  results){ 
            this.relaties.push(<SelectItem>{ label:result["Bedrijf"], value:result["BedrijfID"]});
          }  
          //this.selectedRelaties=this.afdelingen.filter(a=>this.data["relaties"].includes(a.value)).map(a=>a.value);
          },
          (error) => {
          console.error(error);
          });
        }
    btnOpslaan(){
      console.log(this.selectedRelaties);
      this.dialogRef.close(this.selectedRelaties);
     }
  }